import Service from "../../services";
// eslint-disable-next-line no-unused-vars
import Swal from "sweetalert2";

const formSurveyModule = {
  namespaced: true,
  state: {
    form: {
      plant_from: "",
      plant_id: "",
      plant_code: "", //รหัสข้อมูล
      bio_code: "", //รหัสพรรณไม้
      bio_name: "", //ชื่อพืช
      bio_scientific_name: "", //ชื่อวิทยาศาสตร์
      author_name: "", //ชื่อวิทยาศาสตร์
      bio_family_name: "", //ชื่อวงศ์
      bio_species_name: "", //ชื่อพันธ์
      bio_local_name: "", //ชื่อท้องถิ่น
      harvest_season: "", //ฤดูเก็บเกี่ยว
      age: "", //อายุ
      size: "", //เส้นรอบวง
      characteristic: "", //ลักษณะเด่น
      category_id: [], //กลุ่มชนิดพืช

      habit_id: [], //ลักษณะวิสัย
      habit_id_multi: "", //ลักษณะวิสัย
      habit_description: "", //คำอธิบายลักษณะวิสัย
      habitat: [], //แหล่งที่พบ
      habitat_description: "", //คำอธิบายแหล่งที่พบ
      benefit: [], //การใช้ประโยชน์ในท้องถิ่น
      knowledge: [], //ภูมิปัญญาท้องถิ่น

      //แปลงสำรวจ
      survey_plot_code: "", //รหัสแปลง
      survey_plot_name: "", //ชื่อแปลง
      survey_plot_address: "", //ที่ตั้งแปลง
      survey_plot_sub_district: "", //ที่ตั้งแปลง ตำบล
      survey_plot_district: "", //ที่ตั้งแปลง อำเภอ
      survey_plot_province: "", //ที่ตั้งแปลง จังหวัด
      survey_date: "", //วันที่สำรวจพบ
      survey_amount: "", //จำนวนต้นที่พบ
      survey_bio_lat: "", //พิกัดต้นพันธุ์ lat
      survey_bio_lon: "", //พิกัดต้นพันธุ์ lon
      survey_plot_lat: "", //พิกัดแปลง lat
      survey_plot_lon: "", //พิกัดแปลง lon

      //แปลงธนาคาร
      bank_plot_code: "", //รหัสแปลง
      bank_plot_name: "", //ชื่อแปลง
      bank_plot_address: "", //ที่ตั้งแปลง
      bank_plot_sub_district: "", //ที่ตั้งแปลง ตำบล
      bank_plot_district: "", //ที่ตั้งแปลง อำเภอ
      bank_plot_province: "", //ที่ตั้งแปลง จังหวัด
      bank_date: "", //วันที่สำรวจพบ
      bank_amount: "", //จำนวนต้นที่พบ
      bank_bio_lat: "", //พิกัดต้นพันธุ์ lat
      bank_bio_lon: "", //พิกัดต้นพันธุ์ lon
      bank_plot_lat: "", //พิกัดแปลง lat
      bank_plot_lon: "", //พิกัดแปลง lon

      community_id: "", //รหัสชุมชน
      images: [], //รูป
      imageSelected: [null, null, null, null, null],
      status_id: "", //สถานะการตรวจสอบ
      publish_status: "", //สถานะการเผยแพร่
    },
  },

  mutations: {
    BYPASS_BENEFIT(state, data) {
      state.form.benefit = data;
    },
    CLEAR_FORM(state) {
      state.form = {
        plant_from: "",
        plant_id: "",
        plant_code: "", //รหัสข้อมูล
        bio_code: "", //รหัสพรรณไม้
        bio_name: "", //ชื่อพืช
        bio_scientific_name: "", //ชื่อวิทยาศาสตร์
        author_name: "", //ชื่อวิทยาศาสตร์
        bio_local_name: "", //ชื่อท้องถิ่น
        bio_family_name: "", //ชื่อวงศ์
        bio_species_name: "", //ชื่อพันธ์
        harvest_season: "", //ฤดูเก็บเกี่ยว
        age: "", //อายุ
        size: "", //เส้นรอบวง
        characteristic: "", //ลักษณะเด่น
        category_id: [], //กลุ่มชนิดพืช

        habit_id: [], //ลักษณะวิสัย
        habit_id_multi: "", //ลักษณะวิสัย
        habit_description: "", //คำอธิบายลักษณะวิสัย
        habitat: [], //แหล่งที่พบ
        habitat_description: "", //คำอธิบายแหล่งที่พบ
        benefit: [], //การใช้ประโยชน์ในท้องถิ่น
        knowledge: [], //ภูมิปัญญาท้องถิ่น

        //แปลงสำรวจ
        survey_plot_code: "", //รหัสแปลง
        survey_plot_name: "", //ชื่อแปลง
        survey_plot_address: "", //ที่ตั้งแปลง
        survey_plot_sub_district: "", //ที่ตั้งแปลง ตำบล
        survey_plot_district: "", //ที่ตั้งแปลง อำเภอ
        survey_plot_province: "", //ที่ตั้งแปลง จังหวัด
        survey_date: "", //วันที่สำรวจพบ
        survey_amount: "", //จำนวนต้นที่พบ
        survey_bio_lat: "", //พิกัดต้นพันธุ์ lat
        survey_bio_lon: "", //พิกัดต้นพันธุ์ lon
        survey_plot_lat: "", //พิกัดแปลง lat
        survey_plot_lon: "", //พิกัดแปลง lon

        //แปลงธนาคาร
        bank_plot_code: "", //รหัสแปลง
        bank_plot_name: "", //ชื่อแปลง
        bank_plot_address: "", //ที่ตั้งแปลง
        bank_plot_sub_district: "", //ที่ตั้งแปลง ตำบล
        bank_plot_district: "", //ที่ตั้งแปลง อำเภอ
        bank_plot_province: "", //ที่ตั้งแปลง จังหวัด
        bank_date: "", //วันที่สำรวจพบ
        bank_amount: "", //จำนวนต้นที่พบ
        bank_bio_lat: "", //พิกัดต้นพันธุ์ lat
        bank_bio_lon: "", //พิกัดต้นพันธุ์ lon
        bank_plot_lat: "", //พิกัดแปลง lat
        bank_plot_lon: "", //พิกัดแปลง lon

        community_id: "", //รหัสชุมชน
        images: [], //รูป
        imageSelected: [null, null, null, null, null],
        status_id: "", //สถานะการตรวจสอบ
        publish_status: "", //สถานะการเผยแพร่
      };
    },
    SET_FORM(state, res) {
      console.log(res);
      let data = res[0];
      console.log("data res", data);
      state.form = {
        plant_from: data.plant_from,
        plant_id: data.plant_id ? data.plant_id : "",
        plant_code: data.plant_code ? data.plant_code : "", //รหัสข้อมูล
        bio_code: data.bio_code ? data.bio_code : "", //รหัสพรรณไม้
        bio_name: data.bio_name ? data.bio_name : "", //ชื่อพืช
        bio_scientific_name: data.bio_scientific_name
          ? data.bio_scientific_name
          : "", //ชื่อวิทยาศาสตร์
        author_name: data.author_name ? data.author_name : "", //ชื่อวิทยาศาสตร์
        bio_family_name: data.bio_family_name ? data.bio_family_name : "", //ชื่อท้องถิ่น
        bio_species_name: data.bio_species_name ? data.bio_species_name : "", //ชื่อท้องถิ่น

        bio_local_name: data.bio_local_name ? data.bio_local_name : "", //ชื่อท้องถิ่น
        harvest_season: data.harvest_season ? data.harvest_season : "", //ฤดูเก็บเกี่ยว
        age: data.age ? data.age : "", //อายุ
        size: data.size ? data.size : "", //เส้นรอบวง
        characteristic: data.characteristic ? data.characteristic : "", //ลักษณะเด่น
        category_id: data.category_id ? data.category_id : "", //กลุ่มชนิดพืช
        category: data.category ? data.category : null,

        habit_id: data.habit_id ? data.habit_id : "", //ลักษณะวิสัย
        habit_id_multi: data.habit_id_multi ? data.habit_id_multi : "", //ลักษณะวิสัย
        habit: data.habit ? data.habit : null,
        habit_description: data.habit_description ? data.habit_description : "", //คำอธิบายลักษณะวิสัย
        habitat: data.plant_habitat ? data.plant_habitat.habitat_id : null, //แหล่งที่พบ
        habitat_description: data.plant_habitat
          ? data.plant_habitat.habitat_description
          : "", //คำอธิบายแหล่งที่พบ
        plant_benefits: data.plant_benefits ? data.plant_benefits : [],
        plant_knowledges: data.plant_knowledges ? data.plant_knowledges : [],
        // benefit: [],
        // knowledge: [],
        benefit: data.plant_benefits ? data.plant_benefits : "", //การใช้ประโยชน์ในท้องถิ่น
        knowledge: data.plant_knowledges ? data.plant_knowledges : [], //ภูมิปัญญาท้องถิ่น

        //แปลงสำรวจ

        survey_plot_code: data.plant_survey.survey_plot_code
          ? data.plant_survey.survey_plot_code
          : "", //รหัสแปลง
        survey_plot_name: data.plant_survey.survey_plot_name
          ? data.plant_survey.survey_plot_name
          : "", //ชื่อแปลง
        survey_plot_address: data.plant_survey.survey_plot_address
          ? data.plant_survey.survey_plot_address
          : "", //ที่ตั้งแปลง
        survey_plot_sub_district: data.plant_survey.survey_plot_sub_district
          ? data.plant_survey.survey_plot_sub_district
          : null, //ที่ตั้งแปลง ตำบล
        survey_plot_district: data.plant_survey.survey_plot_district
          ? data.plant_survey.survey_plot_district
          : null, //ที่ตั้งแปลง อำเภอ
        survey_plot_province: data.plant_survey.survey_plot_province
          ? data.plant_survey.survey_plot_province
          : null, //ที่ตั้งแปลง จังหวัด
        survey_date: data.plant_survey.survey_date
          ? data.plant_survey.survey_date
          : "", //วันที่สำรวจพบ
        survey_amount: data.plant_survey.survey_amount
          ? data.plant_survey.survey_amount
          : "", //จำนวนต้นที่พบ
        survey_bio_lat: data.plant_survey.survey_bio_lat
          ? data.plant_survey.survey_bio_lat
          : "", //พิกัดต้นพันธุ์ lat
        survey_bio_lon: data.plant_survey.survey_bio_lon
          ? data.plant_survey.survey_bio_lon
          : "", //พิกัดต้นพันธุ์ lon
        survey_plot_lat: data.plant_survey.survey_plot_lat
          ? data.plant_survey.survey_plot_lat
          : "", //พิกัดแปลง lat
        survey_plot_lon: data.plant_survey.survey_plot_lon
          ? data.plant_survey.survey_plot_lon
          : "", //พิกัดแปลง lon

        //แปลงธนาคาร
        bank_plot_code: data.plant_bank ? data.plant_bank.bank_plot_code : "", //รหัสแปลง
        bank_plot_name: data.plant_bank ? data.plant_bank.bank_plot_name : "", //ชื่อแปลง
        bank_plot_address: data.plant_bank
          ? data.plant_bank.bank_plot_address
          : "", //ที่ตั้งแปลง
        bank_plot_sub_district: data.plant_bank
          ? data.plant_bank.bank_plot_sub_district
          : "", //ที่ตั้งแปลง ตำบล
        bank_plot_district: data.plant_bank
          ? data.plant_bank.bank_plot_district
          : "", //ที่ตั้งแปลง อำเภอ
        bank_plot_province: data.plant_bank
          ? data.plant_bank.bank_plot_province
          : "", //ที่ตั้งแปลง จังหวัด
        bank_date: data.plant_bank ? data.plant_bank.bank_date : "", //วันที่สำรวจพบ
        bank_amount: data.plant_bank ? data.plant_bank.bank_amount : "", //จำนวนต้นที่พบ
        bank_bio_lat: data.plant_bank ? data.plant_bank.bank_bio_lat : "", //พิกัดต้นพันธุ์ lat
        bank_bio_lon: data.plant_bank ? data.plant_bank.bank_bio_lon : "", //พิกัดต้นพันธุ์ lon
        bank_plot_lat: data.plant_bank ? data.plant_bank.bank_plot_lat : "", //พิกัดแปลง lat
        bank_plot_lon: data.plant_bank ? data.plant_bank.bank_plot_lon : "", //พิกัดแปลง lon

        community_id: data.community_id, //รหัสชุมชน
        images: data.plant_image, //รูป
        imageSelected: [null, null, null, null, null],
        status_id: data.status_id, //สถานะการตรวจสอบ
        publish_status: data.publish_status, //สถานะการเผยแพร่
      };
      console.log("state.form", state.form);
    },
    SET_IMAGE(state, data) {
      state.form.images.push(data);
      console.log("state.form.image", state.form.images);
    },
  },
  actions: {
    clearForm({ commit }) {
      commit("CLEAR_FORM");
    },
    bypassBenefit({ commit }, data) {
      commit("BYPASS_BENEFIT", data);
    },
    // eslint-disable-next-line no-unused-vars
    getHtmlUtm({ commit }) {
      return Service.FormAPI.getHtmlUtm();
    },
    async getForm({ commit }, id) {
      return Service.FormAPI.getForm(id).then((res) => {
        if (res.code == 200) {
          commit("CLEAR_FORM");
          commit("SET_FORM", res.result);
          return res;
        } else {
          Swal.fire({
            icon: "error",
            title: "ผิดพลาด!",
          });
        }
      });
    },
    // eslint-disable-next-line no-unused-vars
    onSaveForm({ commit }, data) {
      if (data.data.plant_id) {
        return Service.FormAPI.saveEditForm(data).then((res) => {
          if (res.code == 200 && res.message == "success") {
            // commit("CLEAR_FORM");
            console.log("res save", res);
            // this.$store
            //   .dispatch("formSurveyModule/getForm", res.result)
            //   .then(() => {
            //     console.log("res load", res);
            //     Swal.fire({
            //       icon: "success",
            //       title: "เรียบร้อย!",
            //     });
            return res;
            // });
          } else {
            Swal.fire({
              icon: "error",
              title: "ผิดพลาด!",
            });
          }
        });
      } else {
        return Service.FormAPI.saveForm(data).then((res) => {
          if (res.code == 200) {
            console.log("res save", res);
            // commit("CLEAR_FORM");
            return res;
          } else {
            Swal.fire({
              icon: "error",
              title: "ผิดพลาด!",
            });
          }
        });
      }
    },
    onImportExcel({ commit }, data) {
      return Service.FormAPI.importExcel(data).then((res) => {
        return res;
      });
    },
    check({ commit }, index) {
      console.log(index);
    },
    // eslint-disable-next-line no-unused-vars
    onDeletePlant({ commit }, id) {
      return Service.FormAPI.DeletePlant(id).then((res) => {
        return res;
      });
    },
    // eslint-disable-next-line no-unused-vars
    // onUploadImage({ commit }, data) {
    //   return Service.UploadImageAPI.uploadImage(data).then((res) => {
    //     if (res.code == 200) {
    //       console.log("resxx", res.result);
    //       commit("SET_IMAGE", res.result);
    //     }
    //   });
    // },
  },
};

export default formSurveyModule;
